import { createContext, useContext } from 'react'

interface SelfcareAuthContextType {
    isAuthenticated: boolean
    isLoading: boolean
    checkAuthentication: () => void
}

export const SelfcareAuthContext = createContext<
    SelfcareAuthContextType | undefined
>(undefined)

export const useSelfcareAuth = () => {
    const context = useContext(SelfcareAuthContext)
    if (!context) {
        throw new Error('useAuth must be used within an AuthProvider')
    }
    return context
}
